module.exports = __webpack_public_path__ + "static/media/chodba-prizemi-zadni-cela.302b2a78.jpg";